export default "__VITE_ASSET__HLvWnKaj__"